import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import slashOutline from "@iconify/icons-eva/slash-outline";
import checkmarkCircle from "@iconify/icons-eva/checkmark-circle-2-outline";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getUserDetailUrl, getUserStatusUrl } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
import { useIsGrandParent } from "src/hooks/useIsGrandParent";
import { useIsRootSuperAdmin } from "src/hooks/useIsRootSuperAdmin";
export const UserActionMenu = ({ id, row }) => {
  const isReadOnly = useAccess(FEATURE.USERS, "R");
  const hasEditAccess = useAccess(FEATURE.USERS, "U");
  const hasDeleteAccess = useAccess(FEATURE.USERS, "D");
  // Only the super admin (Grand Parent company) may enable/disable a system user.
  const isGrandParent = useIsGrandParent();
  const isRootSuperAdmin = useIsRootSuperAdmin();
  // Mirrors restrictGrandParentUserAdminToRoot on the API: inside the Grand
  // Parent company, disabling or deleting a user means acting on a fellow super
  // admin, which only the ROOT owner may do.
  const canAdministerUser = !isGrandParent || isRootSuperAdmin;
  const isActive = row?.active !== "N";
  const { mutate } = useMutate("users");
  const onDelete = useCallback(() => {
    mutate({ url: getUserDetailUrl(id), method: "DELETE" });
  }, [id, mutate]);
  const onToggleStatus = useCallback(() => {
    mutate({
      url: getUserStatusUrl(id),
      method: "PATCH",
      body: { active: isActive ? "N" : "Y" },
    });
  }, [id, isActive, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "toggle-status",
        title: isActive ? "Disable" : "Enable",
        icon: isActive ? slashOutline : checkmarkCircle,
        action: onToggleStatus,
        hidden: !isGrandParent || !isRootSuperAdmin,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess || !canAdministerUser,
      },
    ],
    [
      id,
      isReadOnly,
      hasEditAccess,
      hasDeleteAccess,
      isGrandParent,
      isRootSuperAdmin,
      canAdministerUser,
      isActive,
      onToggleStatus,
      onDelete,
    ]
  );

  return <ActionsMenu menuList={actionList} />;
};
